export enum Language {
  /**
   * Afar
   */
  Afar = "aar",
  /**
   * Abkhazian
   */
  Abkhazian = "abk",
  /**
   * Achinese
   */
  Achinese = "ace",
  /**
   * Acoli
   */
  Acoli = "ach",
  /**
   * Adangme
   */
  Adangme = "ada",
  /**
   * Adyghe; Adygei
   */
  AdygheAdygei = "ady",
  /**
   * Afro-Asiatic (Other)
   */
  AfroAsiaticOther = "afa",
  /**
   * Afrihili
   */
  Afrihili = "afh",
  /**
   * Afrikaans
   */
  Afrikaans = "afr",
  /**
   * Ainu
   */
  Ainu = "ain",
  /**
   * Akan
   */
  Akan = "aka",
  /**
   * Akkadian
   */
  Akkadian = "akk",
  /**
   * Albanian
   */
  Albanian = "alb",
  /**
   * Aleut
   */
  Aleut = "ale",
  /**
   * Algonquian languages
   */
  AlgonquianLanguages = "alg",
  /**
   * Southern Altai
   */
  SouthernAltai = "alt",
  /**
   * Amharic
   */
  Amharic = "amh",
  /**
   * English, Old (ca.450-1100)
   */
  EnglishOldCa4501100 = "ang",
  /**
   * Angika
   */
  Angika = "anp",
  /**
   * Apache languages
   */
  ApacheLanguages = "apa",
  /**
   * Arabic
   */
  Arabic = "ara",
  /**
   * Aramaic
   */
  Aramaic = "arc",
  /**
   * Aragonese
   */
  Aragonese = "arg",
  /**
   * Armenian
   */
  Armenian = "arm",
  /**
   * Mapudungun; Mapuche
   */
  MapudungunMapuche = "arn",
  /**
   * Arapaho
   */
  Arapaho = "arp",
  /**
   * Artificial (Other)
   */
  ArtificialOther = "art",
  /**
   * Arawak
   */
  Arawak = "arw",
  /**
   * Assamese
   */
  Assamese = "asm",
  /**
   * Asturian; Bable
   */
  AsturianBable = "ast",
  /**
   * Athapascan languages
   */
  AthapascanLanguages = "ath",
  /**
   * Australian languages
   */
  AustralianLanguages = "aus",
  /**
   * Avaric
   */
  Avaric = "ava",
  /**
   * Avestan
   */
  Avestan = "ave",
  /**
   * Awadhi
   */
  Awadhi = "awa",
  /**
   * Aymara
   */
  Aymara = "aym",
  /**
   * Azerbaijani
   */
  Azerbaijani = "aze",
  /**
   * Banda languages
   */
  BandaLanguages = "bad",
  /**
   * Bamileke languages
   */
  BamilekeLanguages = "bai",
  /**
   * Bashkir
   */
  Bashkir = "bak",
  /**
   * Baluchi
   */
  Baluchi = "bal",
  /**
   * Bambara
   */
  Bambara = "bam",
  /**
   * Balinese
   */
  Balinese = "ban",
  /**
   * Basque
   */
  Basque = "baq",
  /**
   * Basa
   */
  Basa = "bas",
  /**
   * Baltic (Other)
   */
  BalticOther = "bat",
  /**
   * Beja
   */
  Beja = "bej",
  /**
   * Belarusian
   */
  Belarusian = "bel",
  /**
   * Bemba
   */
  Bemba = "bem",
  /**
   * Bengali
   */
  Bengali = "ben",
  /**
   * Berber (Other)
   */
  BerberOther = "ber",
  /**
   * Bhojpuri
   */
  Bhojpuri = "bho",
  /**
   * Bihari
   */
  Bihari = "bih",
  /**
   * Bikol
   */
  Bikol = "bik",
  /**
   * Bini; Edo
   */
  BiniEdo = "bin",
  /**
   * Bislama
   */
  Bislama = "bis",
  /**
   * Siksika
   */
  Siksika = "bla",
  /**
   * Bantu (Other)
   */
  BantuOther = "bnt",
  /**
   * Bosnian
   */
  Bosnian = "bos",
  /**
   * Braj
   */
  Braj = "bra",
  /**
   * Breton
   */
  Breton = "bre",
  /**
   * Batak languages
   */
  BatakLanguages = "btk",
  /**
   * Buriat
   */
  Buriat = "bua",
  /**
   * Buginese
   */
  Buginese = "bug",
  /**
   * Bulgarian
   */
  Bulgarian = "bul",
  /**
   * Burmese
   */
  Burmese = "bur",
  /**
   * Blin; Bilin
   */
  BlinBilin = "byn",
  /**
   * Caddo
   */
  Caddo = "cad",
  /**
   * Central American Indian (Other)
   */
  CentralAmericanIndianOther = "cai",
  /**
   * Galibi Carib
   */
  GalibiCarib = "car",
  /**
   * Catalan; Valencian
   */
  CatalanValencian = "cat",
  /**
   * Caucasian (Other)
   */
  CaucasianOther = "cau",
  /**
   * Cebuano
   */
  Cebuano = "ceb",
  /**
   * Celtic (Other)
   */
  CelticOther = "cel",
  /**
   * Chamorro
   */
  Chamorro = "cha",
  /**
   * Chibcha
   */
  Chibcha = "chb",
  /**
   * Chechen
   */
  Chechen = "che",
  /**
   * Chagatai
   */
  Chagatai = "chg",
  /**
   * Chinese
   */
  Chinese = "chi",
  /**
   * Chuukese
   */
  Chuukese = "chk",
  /**
   * Mari
   */
  Mari = "chm",
  /**
   * Chinook jargon
   */
  ChinookJargon = "chn",
  /**
   * Choctaw
   */
  Choctaw = "cho",
  /**
   * Chipewyan
   */
  Chipewyan = "chp",
  /**
   * Cherokee
   */
  Cherokee = "chr",
  /**
   * Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic
   */
  ChurchSlavicOldSlavonicChurchSlavonicOldBulgarianOldChurchSlavonic = "chu",
  /**
   * Chuvash
   */
  Chuvash = "chv",
  /**
   * Cheyenne
   */
  Cheyenne = "chy",
  /**
   * Chamic languages
   */
  ChamicLanguages = "cmc",
  /**
   * Coptic
   */
  Coptic = "cop",
  /**
   * Cornish
   */
  Cornish = "cor",
  /**
   * Corsican
   */
  Corsican = "cos",
  /**
   * Creoles and pidgins, English based (Other)
   */
  CreolesAndPidginsEnglishBasedOther = "cpe",
  /**
   * Creoles and pidgins, French-based (Other)
   */
  CreolesAndPidginsFrenchBasedOther = "cpf",
  /**
   * Creoles and pidgins, Portuguese-based (Other)
   */
  CreolesAndPidginsPortugueseBasedOther = "cpp",
  /**
   * Cree
   */
  Cree = "cre",
  /**
   * Crimean Tatar; Crimean Turkish
   */
  CrimeanTatarCrimeanTurkish = "crh",
  /**
   * Creoles and pidgins (Other)
   */
  CreolesAndPidginsOther = "crp",
  /**
   * Kashubian
   */
  Kashubian = "csb",
  /**
   * Cushitic (Other)
   */
  CushiticOther = "cus",
  /**
   * Czech
   */
  Czech = "cze",
  /**
   * Dakota
   */
  Dakota = "dak",
  /**
   * Danish
   */
  Danish = "dan",
  /**
   * Dargwa
   */
  Dargwa = "dar",
  /**
   * Land Dayak languages
   */
  LandDayakLanguages = "day",
  /**
   * Delaware
   */
  Delaware = "del",
  /**
   * Slave (Athapascan)
   */
  SlaveAthapascan = "den",
  /**
   * Dogrib
   */
  Dogrib = "dgr",
  /**
   * Dinka
   */
  Dinka = "din",
  /**
   * Divehi; Dhivehi; Maldivian
   */
  DivehiDhivehiMaldivian = "div",
  /**
   * Dogri
   */
  Dogri = "doi",
  /**
   * Dravidian (Other)
   */
  DravidianOther = "dra",
  /**
   * Lower Sorbian
   */
  LowerSorbian = "dsb",
  /**
   * Duala
   */
  Duala = "dua",
  /**
   * Dutch, Middle (ca.1050-1350)
   */
  DutchMiddleCa10501350 = "dum",
  /**
   * Dutch; Flemish
   */
  DutchFlemish = "dut",
  /**
   * Dyula
   */
  Dyula = "dyu",
  /**
   * Dzongkha
   */
  Dzongkha = "dzo",
  /**
   * Efik
   */
  Efik = "efi",
  /**
   * Egyptian (Ancient)
   */
  EgyptianAncient = "egy",
  /**
   * Ekajuk
   */
  Ekajuk = "eka",
  /**
   * Elamite
   */
  Elamite = "elx",
  /**
   * English
   */
  English = "eng",
  /**
   * English, Middle (1100-1500)
   */
  EnglishMiddle11001500 = "enm",
  /**
   * Esperanto
   */
  Esperanto = "epo",
  /**
   * Estonian
   */
  Estonian = "est",
  /**
   * Ewe
   */
  Ewe = "ewe",
  /**
   * Ewondo
   */
  Ewondo = "ewo",
  /**
   * Fang
   */
  Fang = "fan",
  /**
   * Faroese
   */
  Faroese = "fao",
  /**
   * Fanti
   */
  Fanti = "fat",
  /**
   * Fijian
   */
  Fijian = "fij",
  /**
   * Filipino; Pilipino
   */
  FilipinoPilipino = "fil",
  /**
   * Finnish
   */
  Finnish = "fin",
  /**
   * Finno-Ugrian (Other)
   */
  FinnoUgrianOther = "fiu",
  /**
   * Fon
   */
  Fon = "fon",
  /**
   * French
   */
  French = "fre",
  /**
   * French, Middle (ca.1400-1600)
   */
  FrenchMiddleCa14001600 = "frm",
  /**
   * French, Old (842-ca.1400)
   */
  FrenchOld842Ca1400 = "fro",
  /**
   * Northern Frisian
   */
  NorthernFrisian = "frr",
  /**
   * Eastern Frisian
   */
  EasternFrisian = "frs",
  /**
   * Western Frisian
   */
  WesternFrisian = "fry",
  /**
   * Fulah
   */
  Fulah = "ful",
  /**
   * Friulian
   */
  Friulian = "fur",
  /**
   * Ga
   */
  Ga = "gaa",
  /**
   * Gayo
   */
  Gayo = "gay",
  /**
   * Gbaya
   */
  Gbaya = "gba",
  /**
   * Germanic (Other)
   */
  GermanicOther = "gem",
  /**
   * Georgian
   */
  Georgian = "geo",
  /**
   * German
   */
  German = "ger",
  /**
   * Geez
   */
  Geez = "gez",
  /**
   * Gilbertese
   */
  Gilbertese = "gil",
  /**
   * Gaelic; Scottish Gaelic
   */
  GaelicScottishGaelic = "gla",
  /**
   * Irish
   */
  Irish = "gle",
  /**
   * Galician
   */
  Galician = "glg",
  /**
   * Manx
   */
  Manx = "glv",
  /**
   * German, Middle High (ca.1050-1500)
   */
  GermanMiddleHighCa10501500 = "gmh",
  /**
   * German, Old High (ca.750-1050)
   */
  GermanOldHighCa7501050 = "goh",
  /**
   * Gondi
   */
  Gondi = "gon",
  /**
   * Gorontalo
   */
  Gorontalo = "gor",
  /**
   * Gothic
   */
  Gothic = "got",
  /**
   * Grebo
   */
  Grebo = "grb",
  /**
   * Greek, Ancient (to 1453)
   */
  GreekAncientTo1453 = "grc",
  /**
   * Greek, Modern (1453-)
   */
  GreekModern1453 = "gre",
  /**
   * Guarani
   */
  Guarani = "grn",
  /**
   * Swiss German; Alemannic
   */
  SwissGermanAlemannic = "gsw",
  /**
   * Gujarati
   */
  Gujarati = "guj",
  /**
   * Gwich'in
   */
  Gwichin = "gwi",
  /**
   * Haida
   */
  Haida = "hai",
  /**
   * Haitian; Haitian Creole
   */
  HaitianHaitianCreole = "hat",
  /**
   * Hausa
   */
  Hausa = "hau",
  /**
   * Hawaiian
   */
  Hawaiian = "haw",
  /**
   * Hebrew
   */
  Hebrew = "heb",
  /**
   * Herero
   */
  Herero = "her",
  /**
   * Hiligaynon
   */
  Hiligaynon = "hil",
  /**
   * Himachali
   */
  Himachali = "him",
  /**
   * Hindi
   */
  Hindi = "hin",
  /**
   * Hittite
   */
  Hittite = "hit",
  /**
   * Hmong
   */
  Hmong = "hmn",
  /**
   * Hiri Motu
   */
  HiriMotu = "hmo",
  /**
   * Upper Sorbian
   */
  UpperSorbian = "hsb",
  /**
   * Hungarian
   */
  Hungarian = "hun",
  /**
   * Hupa
   */
  Hupa = "hup",
  /**
   * Iban
   */
  Iban = "iba",
  /**
   * Igbo
   */
  Igbo = "ibo",
  /**
   * Icelandic
   */
  Icelandic = "ice",
  /**
   * Ido
   */
  Ido = "ido",
  /**
   * Sichuan Yi
   */
  SichuanYi = "iii",
  /**
   * Ijo languages
   */
  IjoLanguages = "ijo",
  /**
   * Inuktitut
   */
  Inuktitut = "iku",
  /**
   * Interlingue
   */
  Interlingue = "ile",
  /**
   * Iloko
   */
  Iloko = "ilo",
  /**
   * Interlingua (International Auxiliary Language Association)
   */
  InterlinguaInternationalAuxiliaryLanguageAssociation = "ina",
  /**
   * Indic (Other)
   */
  IndicOther = "inc",
  /**
   * Indonesian
   */
  Indonesian = "ind",
  /**
   * Indo-European (Other)
   */
  IndoEuropeanOther = "ine",
  /**
   * Ingush
   */
  Ingush = "inh",
  /**
   * Inupiaq
   */
  Inupiaq = "ipk",
  /**
   * Iranian (Other)
   */
  IranianOther = "ira",
  /**
   * Iroquoian languages
   */
  IroquoianLanguages = "iro",
  /**
   * Italian
   */
  Italian = "ita",
  /**
   * Javanese
   */
  Javanese = "jav",
  /**
   * Lojban
   */
  Lojban = "jbo",
  /**
   * Japanese
   */
  Japanese = "jpn",
  /**
   * Judeo-Persian
   */
  JudeoPersian = "jpr",
  /**
   * Judeo-Arabic
   */
  JudeoArabic = "jrb",
  /**
   * Kara-Kalpak
   */
  KaraKalpak = "kaa",
  /**
   * Kabyle
   */
  Kabyle = "kab",
  /**
   * Kachin; Jingpho
   */
  KachinJingpho = "kac",
  /**
   * Kalaallisut; Greenlandic
   */
  KalaallisutGreenlandic = "kal",
  /**
   * Kamba
   */
  Kamba = "kam",
  /**
   * Kannada
   */
  Kannada = "kan",
  /**
   * Karen languages
   */
  KarenLanguages = "kar",
  /**
   * Kashmiri
   */
  Kashmiri = "kas",
  /**
   * Kanuri
   */
  Kanuri = "kau",
  /**
   * Kawi
   */
  Kawi = "kaw",
  /**
   * Kazakh
   */
  Kazakh = "kaz",
  /**
   * Kabardian
   */
  Kabardian = "kbd",
  /**
   * Khasi
   */
  Khasi = "kha",
  /**
   * Khoisan (Other)
   */
  KhoisanOther = "khi",
  /**
   * Central Khmer
   */
  CentralKhmer = "khm",
  /**
   * Khotanese
   */
  Khotanese = "kho",
  /**
   * Kikuyu; Gikuyu
   */
  KikuyuGikuyu = "kik",
  /**
   * Kinyarwanda
   */
  Kinyarwanda = "kin",
  /**
   * Kirghiz; Kyrgyz
   */
  KirghizKyrgyz = "kir",
  /**
   * Kimbundu
   */
  Kimbundu = "kmb",
  /**
   * Konkani
   */
  Konkani = "kok",
  /**
   * Komi
   */
  Komi = "kom",
  /**
   * Kongo
   */
  Kongo = "kon",
  /**
   * Korean
   */
  Korean = "kor",
  /**
   * Kosraean
   */
  Kosraean = "kos",
  /**
   * Kpelle
   */
  Kpelle = "kpe",
  /**
   * Karachay-Balkar
   */
  KarachayBalkar = "krc",
  /**
   * Karelian
   */
  Karelian = "krl",
  /**
   * Kru languages
   */
  KruLanguages = "kro",
  /**
   * Kurukh
   */
  Kurukh = "kru",
  /**
   * Kuanyama; Kwanyama
   */
  KuanyamaKwanyama = "kua",
  /**
   * Kumyk
   */
  Kumyk = "kum",
  /**
   * Kurdish
   */
  Kurdish = "kur",
  /**
   * Kutenai
   */
  Kutenai = "kut",
  /**
   * Ladino
   */
  Ladino = "lad",
  /**
   * Lahnda
   */
  Lahnda = "lah",
  /**
   * Lamba
   */
  Lamba = "lam",
  /**
   * Lao
   */
  Lao = "lao",
  /**
   * Latin
   */
  Latin = "lat",
  /**
   * Latvian
   */
  Latvian = "lav",
  /**
   * Lezghian
   */
  Lezghian = "lez",
  /**
   * Limburgan; Limburger; Limburgish
   */
  LimburganLimburgerLimburgish = "lim",
  /**
   * Lingala
   */
  Lingala = "lin",
  /**
   * Lithuanian
   */
  Lithuanian = "lit",
  /**
   * Mongo
   */
  Mongo = "lol",
  /**
   * Lozi
   */
  Lozi = "loz",
  /**
   * Luxembourgish; Letzeburgesch
   */
  LuxembourgishLetzeburgesch = "ltz",
  /**
   * Luba-Lulua
   */
  LubaLulua = "lua",
  /**
   * Luba-Katanga
   */
  LubaKatanga = "lub",
  /**
   * Ganda
   */
  Ganda = "lug",
  /**
   * Luiseno
   */
  Luiseno = "lui",
  /**
   * Lunda
   */
  Lunda = "lun",
  /**
   * Luo (Kenya and Tanzania)
   */
  LuoKenyaAndTanzania = "luo",
  /**
   * Lushai
   */
  Lushai = "lus",
  /**
   * Macedonian
   */
  Macedonian = "mac",
  /**
   * Madurese
   */
  Madurese = "mad",
  /**
   * Magahi
   */
  Magahi = "mag",
  /**
   * Marshallese
   */
  Marshallese = "mah",
  /**
   * Maithili
   */
  Maithili = "mai",
  /**
   * Makasar
   */
  Makasar = "mak",
  /**
   * Malayalam
   */
  Malayalam = "mal",
  /**
   * Mandingo
   */
  Mandingo = "man",
  /**
   * Maori
   */
  Maori = "mao",
  /**
   * Austronesian (Other)
   */
  AustronesianOther = "map",
  /**
   * Marathi
   */
  Marathi = "mar",
  /**
   * Masai
   */
  Masai = "mas",
  /**
   * Malay
   */
  Malay = "may",
  /**
   * Moksha
   */
  Moksha = "mdf",
  /**
   * Mandar
   */
  Mandar = "mdr",
  /**
   * Mende
   */
  Mende = "men",
  /**
   * Irish, Middle (900-1200)
   */
  IrishMiddle9001200 = "mga",
  /**
   * Mi'kmaq; Micmac
   */
  MikmaqMicmac = "mic",
  /**
   * Minangkabau
   */
  Minangkabau = "min",
  /**
   * Miscellaneous languages
   */
  MiscellaneousLanguages = "mis",
  /**
   * Mon-Khmer (Other)
   */
  MonKhmerOther = "mkh",
  /**
   * Malagasy
   */
  Malagasy = "mlg",
  /**
   * Maltese
   */
  Maltese = "mlt",
  /**
   * Manchu
   */
  Manchu = "mnc",
  /**
   * Manipuri
   */
  Manipuri = "mni",
  /**
   * Manobo languages
   */
  ManoboLanguages = "mno",
  /**
   * Mohawk
   */
  Mohawk = "moh",
  /**
   * Moldavian
   */
  Moldavian = "mol",
  /**
   * Mongolian
   */
  Mongolian = "mon",
  /**
   * Mossi
   */
  Mossi = "mos",
  /**
   * Multiple languages
   */
  MultipleLanguages = "mul",
  /**
   * Munda languages
   */
  MundaLanguages = "mun",
  /**
   * Creek
   */
  Creek = "mus",
  /**
   * Mirandese
   */
  Mirandese = "mwl",
  /**
   * Marwari
   */
  Marwari = "mwr",
  /**
   * Mayan languages
   */
  MayanLanguages = "myn",
  /**
   * Erzya
   */
  Erzya = "myv",
  /**
   * Nahuatl languages
   */
  NahuatlLanguages = "nah",
  /**
   * North American Indian
   */
  NorthAmericanIndian = "nai",
  /**
   * Neapolitan
   */
  Neapolitan = "nap",
  /**
   * Nauru
   */
  Nauru = "nau",
  /**
   * Navajo; Navaho
   */
  NavajoNavaho = "nav",
  /**
   * Ndebele, South; South Ndebele
   */
  NdebeleSouthSouthNdebele = "nbl",
  /**
   * Ndebele, North; North Ndebele
   */
  NdebeleNorthNorthNdebele = "nde",
  /**
   * Ndonga
   */
  Ndonga = "ndo",
  /**
   * Low German; Low Saxon; German, Low; Saxon, Low
   */
  LowGermanLowSaxonGermanLowSaxonLow = "nds",
  /**
   * Nepali
   */
  Nepali = "nep",
  /**
   * Nepal Bhasa; Newari
   */
  NepalBhasaNewari = "new",
  /**
   * Nias
   */
  Nias = "nia",
  /**
   * Niger-Kordofanian (Other)
   */
  NigerKordofanianOther = "nic",
  /**
   * Niuean
   */
  Niuean = "niu",
  /**
   * Norwegian Nynorsk; Nynorsk, Norwegian
   */
  NorwegianNynorskNynorskNorwegian = "nno",
  /**
   * Bokmål, Norwegian; Norwegian Bokmål
   */
  BokmålNorwegianNorwegianBokmål = "nob",
  /**
   * Nogai
   */
  Nogai = "nog",
  /**
   * Norse, Old
   */
  NorseOld = "non",
  /**
   * Norwegian
   */
  Norwegian = "nor",
  /**
   * N'Ko
   */
  Nko = "nqo",
  /**
   * Pedi; Sepedi; Northern Sotho
   */
  PediSepediNorthernSotho = "nso",
  /**
   * Nubian languages
   */
  NubianLanguages = "nub",
  /**
   * Classical Newari; Old Newari; Classical Nepal Bhasa
   */
  ClassicalNewariOldNewariClassicalNepalBhasa = "nwc",
  /**
   * Chichewa; Chewa; Nyanja
   */
  ChichewaChewaNyanja = "nya",
  /**
   * Nyamwezi
   */
  Nyamwezi = "nym",
  /**
   * Nyankole
   */
  Nyankole = "nyn",
  /**
   * Nyoro
   */
  Nyoro = "nyo",
  /**
   * Nzima
   */
  Nzima = "nzi",
  /**
   * Occitan (post 1500); Provençal
   */
  OccitanPost1500Provençal = "oci",
  /**
   * Ojibwa
   */
  Ojibwa = "oji",
  /**
   * Oriya
   */
  Oriya = "ori",
  /**
   * Oromo
   */
  Oromo = "orm",
  /**
   * Osage
   */
  Osage = "osa",
  /**
   * Ossetian; Ossetic
   */
  OssetianOssetic = "oss",
  /**
   * Turkish, Ottoman (1500-1928)
   */
  TurkishOttoman15001928 = "ota",
  /**
   * Otomian languages
   */
  OtomianLanguages = "oto",
  /**
   * Papuan (Other)
   */
  PapuanOther = "paa",
  /**
   * Pangasinan
   */
  Pangasinan = "pag",
  /**
   * Pahlavi
   */
  Pahlavi = "pal",
  /**
   * Pampanga
   */
  Pampanga = "pam",
  /**
   * Panjabi; Punjabi
   */
  PanjabiPunjabi = "pan",
  /**
   * Papiamento
   */
  Papiamento = "pap",
  /**
   * Palauan
   */
  Palauan = "pau",
  /**
   * Persian, Old (ca.600-400 B.C.)
   */
  PersianOldCa600400BC = "peo",
  /**
   * Persian
   */
  Persian = "per",
  /**
   * Philippine (Other)
   */
  PhilippineOther = "phi",
  /**
   * Phoenician
   */
  Phoenician = "phn",
  /**
   * Pali
   */
  Pali = "pli",
  /**
   * Polish
   */
  Polish = "pol",
  /**
   * Pohnpeian
   */
  Pohnpeian = "pon",
  /**
   * Portuguese
   */
  Portuguese = "por",
  /**
   * Prakrit languages
   */
  PrakritLanguages = "pra",
  /**
   * Provençal, Old (to 1500)
   */
  ProvençalOldTo1500 = "pro",
  /**
   * Pushto
   */
  Pushto = "pus",
  /**
   * Quechua
   */
  Quechua = "que",
  /**
   * Rajasthani
   */
  Rajasthani = "raj",
  /**
   * Rapanui
   */
  Rapanui = "rap",
  /**
   * Rarotongan; Cook Islands Maori
   */
  RarotonganCookIslandsMaori = "rar",
  /**
   * Romance (Other)
   */
  RomanceOther = "roa",
  /**
   * Romansh
   */
  Romansh = "roh",
  /**
   * Romany
   */
  Romany = "rom",
  /**
   * Romanian
   */
  Romanian = "rum",
  /**
   * Rundi
   */
  Rundi = "run",
  /**
   * Aromanian; Arumanian; Macedo-Romanian
   */
  AromanianArumanianMacedoRomanian = "rup",
  /**
   * Russian
   */
  Russian = "rus",
  /**
   * Sandawe
   */
  Sandawe = "sad",
  /**
   * Sango
   */
  Sango = "sag",
  /**
   * Yakut
   */
  Yakut = "sah",
  /**
   * South American Indian (Other)
   */
  SouthAmericanIndianOther = "sai",
  /**
   * Salishan languages
   */
  SalishanLanguages = "sal",
  /**
   * Samaritan Aramaic
   */
  SamaritanAramaic = "sam",
  /**
   * Sanskrit
   */
  Sanskrit = "san",
  /**
   * Sasak
   */
  Sasak = "sas",
  /**
   * Santali
   */
  Santali = "sat",
  /**
   * Serbian
   */
  Serbian = "scc",
  /**
   * Sicilian
   */
  Sicilian = "scn",
  /**
   * Scots
   */
  Scots = "sco",
  /**
   * Croatian
   */
  Croatian = "scr",
  /**
   * Selkup
   */
  Selkup = "sel",
  /**
   * Semitic (Other)
   */
  SemiticOther = "sem",
  /**
   * Irish, Old (to 900)
   */
  IrishOldTo900 = "sga",
  /**
   * Sign Languages
   */
  SignLanguages = "sgn",
  /**
   * Shan
   */
  Shan = "shn",
  /**
   * Sidamo
   */
  Sidamo = "sid",
  /**
   * Sinhala; Sinhalese
   */
  SinhalaSinhalese = "sin",
  /**
   * Siouan languages
   */
  SiouanLanguages = "sio",
  /**
   * Sino-Tibetan (Other)
   */
  SinoTibetanOther = "sit",
  /**
   * Slavic (Other)
   */
  SlavicOther = "sla",
  /**
   * Slovak
   */
  Slovak = "slo",
  /**
   * Slovenian
   */
  Slovenian = "slv",
  /**
   * Southern Sami
   */
  SouthernSami = "sma",
  /**
   * Northern Sami
   */
  NorthernSami = "sme",
  /**
   * Sami languages (Other)
   */
  SamiLanguagesOther = "smi",
  /**
   * Lule Sami
   */
  LuleSami = "smj",
  /**
   * Inari Sami
   */
  InariSami = "smn",
  /**
   * Samoan
   */
  Samoan = "smo",
  /**
   * Skolt Sami
   */
  SkoltSami = "sms",
  /**
   * Shona
   */
  Shona = "sna",
  /**
   * Sindhi
   */
  Sindhi = "snd",
  /**
   * Soninke
   */
  Soninke = "snk",
  /**
   * Sogdian
   */
  Sogdian = "sog",
  /**
   * Somali
   */
  Somali = "som",
  /**
   * Songhai languages
   */
  SonghaiLanguages = "son",
  /**
   * Sotho, Southern
   */
  SothoSouthern = "sot",
  /**
   * Spanish; Castilian
   */
  SpanishCastilian = "spa",
  /**
   * Sardinian
   */
  Sardinian = "srd",
  /**
   * Sranan Tongo
   */
  SrananTongo = "srn",
  /**
   * Serer
   */
  Serer = "srr",
  /**
   * Nilo-Saharan (Other)
   */
  NiloSaharanOther = "ssa",
  /**
   * Swati
   */
  Swati = "ssw",
  /**
   * Sukuma
   */
  Sukuma = "suk",
  /**
   * Sundanese
   */
  Sundanese = "sun",
  /**
   * Susu
   */
  Susu = "sus",
  /**
   * Sumerian
   */
  Sumerian = "sux",
  /**
   * Swahili
   */
  Swahili = "swa",
  /**
   * Swedish
   */
  Swedish = "swe",
  /**
   * Syriac
   */
  Syriac = "syr",
  /**
   * Tahitian
   */
  Tahitian = "tah",
  /**
   * Tai (Other)
   */
  TaiOther = "tai",
  /**
   * Tamil
   */
  Tamil = "tam",
  /**
   * Tatar
   */
  Tatar = "tat",
  /**
   * Telugu
   */
  Telugu = "tel",
  /**
   * Timne
   */
  Timne = "tem",
  /**
   * Tereno
   */
  Tereno = "ter",
  /**
   * Tetum
   */
  Tetum = "tet",
  /**
   * Tajik
   */
  Tajik = "tgk",
  /**
   * Tagalog
   */
  Tagalog = "tgl",
  /**
   * Thai
   */
  Thai = "tha",
  /**
   * Tibetan
   */
  Tibetan = "tib",
  /**
   * Tigre
   */
  Tigre = "tig",
  /**
   * Tigrinya
   */
  Tigrinya = "tir",
  /**
   * Tiv
   */
  Tiv = "tiv",
  /**
   * Tokelau
   */
  Tokelau = "tkl",
  /**
   * Klingon; tlhIngan-Hol
   */
  KlingonTlhinganHol = "tlh",
  /**
   * Tlingit
   */
  Tlingit = "tli",
  /**
   * Tamashek
   */
  Tamashek = "tmh",
  /**
   * Tonga (Nyasa)
   */
  TongaNyasa = "tog",
  /**
   * Tonga (Tonga Islands)
   */
  TongaTongaIslands = "ton",
  /**
   * Tok Pisin
   */
  TokPisin = "tpi",
  /**
   * Tsimshian
   */
  Tsimshian = "tsi",
  /**
   * Tswana
   */
  Tswana = "tsn",
  /**
   * Tsonga
   */
  Tsonga = "tso",
  /**
   * Turkmen
   */
  Turkmen = "tuk",
  /**
   * Tumbuka
   */
  Tumbuka = "tum",
  /**
   * Tupi languages
   */
  TupiLanguages = "tup",
  /**
   * Turkish
   */
  Turkish = "tur",
  /**
   * Altaic (Other)
   */
  AltaicOther = "tut",
  /**
   * Tuvalu
   */
  Tuvalu = "tvl",
  /**
   * Twi
   */
  Twi = "twi",
  /**
   * Tuvinian
   */
  Tuvinian = "tyv",
  /**
   * Udmurt
   */
  Udmurt = "udm",
  /**
   * Ugaritic
   */
  Ugaritic = "uga",
  /**
   * Uighur; Uyghur
   */
  UighurUyghur = "uig",
  /**
   * Ukrainian
   */
  Ukrainian = "ukr",
  /**
   * Umbundu
   */
  Umbundu = "umb",
  /**
   * Undetermined
   */
  Undetermined = "und",
  /**
   * Urdu
   */
  Urdu = "urd",
  /**
   * Uzbek
   */
  Uzbek = "uzb",
  /**
   * Vai
   */
  Vai = "vai",
  /**
   * Venda
   */
  Venda = "ven",
  /**
   * Vietnamese
   */
  Vietnamese = "vie",
  /**
   * Volapük
   */
  Volapük = "vol",
  /**
   * Votic
   */
  Votic = "vot",
  /**
   * Wakashan languages
   */
  WakashanLanguages = "wak",
  /**
   * Walamo
   */
  Walamo = "wal",
  /**
   * Waray
   */
  Waray = "war",
  /**
   * Washo
   */
  Washo = "was",
  /**
   * Welsh
   */
  Welsh = "wel",
  /**
   * Sorbian languages
   */
  SorbianLanguages = "wen",
  /**
   * Walloon
   */
  Walloon = "wln",
  /**
   * Wolof
   */
  Wolof = "wol",
  /**
   * Kalmyk; Oirat
   */
  KalmykOirat = "xal",
  /**
   * Xhosa
   */
  Xhosa = "xho",
  /**
   * Yao
   */
  Yao = "yao",
  /**
   * Yapese
   */
  Yapese = "yap",
  /**
   * Yiddish
   */
  Yiddish = "yid",
  /**
   * Yoruba
   */
  Yoruba = "yor",
  /**
   * Yupik languages
   */
  YupikLanguages = "ypk",
  /**
   * Zapotec
   */
  Zapotec = "zap",
  /**
   * Zenaga
   */
  Zenaga = "zen",
  /**
   * Zhuang; Chuang
   */
  ZhuangChuang = "zha",
  /**
   * Zande languages
   */
  ZandeLanguages = "znd",
  /**
   * Zulu
   */
  Zulu = "zul",
  /**
   * Zuni
   */
  Zuni = "zun",
  /**
   * No linguistic content
   */
  NoLinguisticContent = "zxx",
  /**
   * Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki.
   */
  ZazaDimiliDimliKirdkiKirmanjkiZazaki = "zza",
}

export function description(value: Language): string {
  switch (value) {
    case Language.Afar:
      return "Afar";
    case Language.Abkhazian:
      return "Abkhazian";
    case Language.Achinese:
      return "Achinese";
    case Language.Acoli:
      return "Acoli";
    case Language.Adangme:
      return "Adangme";
    case Language.AdygheAdygei:
      return "Adyghe; Adygei";
    case Language.AfroAsiaticOther:
      return "Afro-Asiatic (Other)";
    case Language.Afrihili:
      return "Afrihili";
    case Language.Afrikaans:
      return "Afrikaans";
    case Language.Ainu:
      return "Ainu";
    case Language.Akan:
      return "Akan";
    case Language.Akkadian:
      return "Akkadian";
    case Language.Albanian:
      return "Albanian";
    case Language.Aleut:
      return "Aleut";
    case Language.AlgonquianLanguages:
      return "Algonquian languages";
    case Language.SouthernAltai:
      return "Southern Altai";
    case Language.Amharic:
      return "Amharic";
    case Language.EnglishOldCa4501100:
      return "English, Old (ca.450-1100)";
    case Language.Angika:
      return "Angika";
    case Language.ApacheLanguages:
      return "Apache languages";
    case Language.Arabic:
      return "Arabic";
    case Language.Aramaic:
      return "Aramaic";
    case Language.Aragonese:
      return "Aragonese";
    case Language.Armenian:
      return "Armenian";
    case Language.MapudungunMapuche:
      return "Mapudungun; Mapuche";
    case Language.Arapaho:
      return "Arapaho";
    case Language.ArtificialOther:
      return "Artificial (Other)";
    case Language.Arawak:
      return "Arawak";
    case Language.Assamese:
      return "Assamese";
    case Language.AsturianBable:
      return "Asturian; Bable";
    case Language.AthapascanLanguages:
      return "Athapascan languages";
    case Language.AustralianLanguages:
      return "Australian languages";
    case Language.Avaric:
      return "Avaric";
    case Language.Avestan:
      return "Avestan";
    case Language.Awadhi:
      return "Awadhi";
    case Language.Aymara:
      return "Aymara";
    case Language.Azerbaijani:
      return "Azerbaijani";
    case Language.BandaLanguages:
      return "Banda languages";
    case Language.BamilekeLanguages:
      return "Bamileke languages";
    case Language.Bashkir:
      return "Bashkir";
    case Language.Baluchi:
      return "Baluchi";
    case Language.Bambara:
      return "Bambara";
    case Language.Balinese:
      return "Balinese";
    case Language.Basque:
      return "Basque";
    case Language.Basa:
      return "Basa";
    case Language.BalticOther:
      return "Baltic (Other)";
    case Language.Beja:
      return "Beja";
    case Language.Belarusian:
      return "Belarusian";
    case Language.Bemba:
      return "Bemba";
    case Language.Bengali:
      return "Bengali";
    case Language.BerberOther:
      return "Berber (Other)";
    case Language.Bhojpuri:
      return "Bhojpuri";
    case Language.Bihari:
      return "Bihari";
    case Language.Bikol:
      return "Bikol";
    case Language.BiniEdo:
      return "Bini; Edo";
    case Language.Bislama:
      return "Bislama";
    case Language.Siksika:
      return "Siksika";
    case Language.BantuOther:
      return "Bantu (Other)";
    case Language.Bosnian:
      return "Bosnian";
    case Language.Braj:
      return "Braj";
    case Language.Breton:
      return "Breton";
    case Language.BatakLanguages:
      return "Batak languages";
    case Language.Buriat:
      return "Buriat";
    case Language.Buginese:
      return "Buginese";
    case Language.Bulgarian:
      return "Bulgarian";
    case Language.Burmese:
      return "Burmese";
    case Language.BlinBilin:
      return "Blin; Bilin";
    case Language.Caddo:
      return "Caddo";
    case Language.CentralAmericanIndianOther:
      return "Central American Indian (Other)";
    case Language.GalibiCarib:
      return "Galibi Carib";
    case Language.CatalanValencian:
      return "Catalan; Valencian";
    case Language.CaucasianOther:
      return "Caucasian (Other)";
    case Language.Cebuano:
      return "Cebuano";
    case Language.CelticOther:
      return "Celtic (Other)";
    case Language.Chamorro:
      return "Chamorro";
    case Language.Chibcha:
      return "Chibcha";
    case Language.Chechen:
      return "Chechen";
    case Language.Chagatai:
      return "Chagatai";
    case Language.Chinese:
      return "Chinese";
    case Language.Chuukese:
      return "Chuukese";
    case Language.Mari:
      return "Mari";
    case Language.ChinookJargon:
      return "Chinook jargon";
    case Language.Choctaw:
      return "Choctaw";
    case Language.Chipewyan:
      return "Chipewyan";
    case Language.Cherokee:
      return "Cherokee";
    case Language.ChurchSlavicOldSlavonicChurchSlavonicOldBulgarianOldChurchSlavonic:
      return "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic";
    case Language.Chuvash:
      return "Chuvash";
    case Language.Cheyenne:
      return "Cheyenne";
    case Language.ChamicLanguages:
      return "Chamic languages";
    case Language.Coptic:
      return "Coptic";
    case Language.Cornish:
      return "Cornish";
    case Language.Corsican:
      return "Corsican";
    case Language.CreolesAndPidginsEnglishBasedOther:
      return "Creoles and pidgins, English based (Other)";
    case Language.CreolesAndPidginsFrenchBasedOther:
      return "Creoles and pidgins, French-based (Other)";
    case Language.CreolesAndPidginsPortugueseBasedOther:
      return "Creoles and pidgins, Portuguese-based (Other)";
    case Language.Cree:
      return "Cree";
    case Language.CrimeanTatarCrimeanTurkish:
      return "Crimean Tatar; Crimean Turkish";
    case Language.CreolesAndPidginsOther:
      return "Creoles and pidgins (Other)";
    case Language.Kashubian:
      return "Kashubian";
    case Language.CushiticOther:
      return "Cushitic (Other)";
    case Language.Czech:
      return "Czech";
    case Language.Dakota:
      return "Dakota";
    case Language.Danish:
      return "Danish";
    case Language.Dargwa:
      return "Dargwa";
    case Language.LandDayakLanguages:
      return "Land Dayak languages";
    case Language.Delaware:
      return "Delaware";
    case Language.SlaveAthapascan:
      return "Slave (Athapascan)";
    case Language.Dogrib:
      return "Dogrib";
    case Language.Dinka:
      return "Dinka";
    case Language.DivehiDhivehiMaldivian:
      return "Divehi; Dhivehi; Maldivian";
    case Language.Dogri:
      return "Dogri";
    case Language.DravidianOther:
      return "Dravidian (Other)";
    case Language.LowerSorbian:
      return "Lower Sorbian";
    case Language.Duala:
      return "Duala";
    case Language.DutchMiddleCa10501350:
      return "Dutch, Middle (ca.1050-1350)";
    case Language.DutchFlemish:
      return "Dutch; Flemish";
    case Language.Dyula:
      return "Dyula";
    case Language.Dzongkha:
      return "Dzongkha";
    case Language.Efik:
      return "Efik";
    case Language.EgyptianAncient:
      return "Egyptian (Ancient)";
    case Language.Ekajuk:
      return "Ekajuk";
    case Language.Elamite:
      return "Elamite";
    case Language.English:
      return "English";
    case Language.EnglishMiddle11001500:
      return "English, Middle (1100-1500)";
    case Language.Esperanto:
      return "Esperanto";
    case Language.Estonian:
      return "Estonian";
    case Language.Ewe:
      return "Ewe";
    case Language.Ewondo:
      return "Ewondo";
    case Language.Fang:
      return "Fang";
    case Language.Faroese:
      return "Faroese";
    case Language.Fanti:
      return "Fanti";
    case Language.Fijian:
      return "Fijian";
    case Language.FilipinoPilipino:
      return "Filipino; Pilipino";
    case Language.Finnish:
      return "Finnish";
    case Language.FinnoUgrianOther:
      return "Finno-Ugrian (Other)";
    case Language.Fon:
      return "Fon";
    case Language.French:
      return "French";
    case Language.FrenchMiddleCa14001600:
      return "French, Middle (ca.1400-1600)";
    case Language.FrenchOld842Ca1400:
      return "French, Old (842-ca.1400)";
    case Language.NorthernFrisian:
      return "Northern Frisian";
    case Language.EasternFrisian:
      return "Eastern Frisian";
    case Language.WesternFrisian:
      return "Western Frisian";
    case Language.Fulah:
      return "Fulah";
    case Language.Friulian:
      return "Friulian";
    case Language.Ga:
      return "Ga";
    case Language.Gayo:
      return "Gayo";
    case Language.Gbaya:
      return "Gbaya";
    case Language.GermanicOther:
      return "Germanic (Other)";
    case Language.Georgian:
      return "Georgian";
    case Language.German:
      return "German";
    case Language.Geez:
      return "Geez";
    case Language.Gilbertese:
      return "Gilbertese";
    case Language.GaelicScottishGaelic:
      return "Gaelic; Scottish Gaelic";
    case Language.Irish:
      return "Irish";
    case Language.Galician:
      return "Galician";
    case Language.Manx:
      return "Manx";
    case Language.GermanMiddleHighCa10501500:
      return "German, Middle High (ca.1050-1500)";
    case Language.GermanOldHighCa7501050:
      return "German, Old High (ca.750-1050)";
    case Language.Gondi:
      return "Gondi";
    case Language.Gorontalo:
      return "Gorontalo";
    case Language.Gothic:
      return "Gothic";
    case Language.Grebo:
      return "Grebo";
    case Language.GreekAncientTo1453:
      return "Greek, Ancient (to 1453)";
    case Language.GreekModern1453:
      return "Greek, Modern (1453-)";
    case Language.Guarani:
      return "Guarani";
    case Language.SwissGermanAlemannic:
      return "Swiss German; Alemannic";
    case Language.Gujarati:
      return "Gujarati";
    case Language.Gwichin:
      return "Gwich'in";
    case Language.Haida:
      return "Haida";
    case Language.HaitianHaitianCreole:
      return "Haitian; Haitian Creole";
    case Language.Hausa:
      return "Hausa";
    case Language.Hawaiian:
      return "Hawaiian";
    case Language.Hebrew:
      return "Hebrew";
    case Language.Herero:
      return "Herero";
    case Language.Hiligaynon:
      return "Hiligaynon";
    case Language.Himachali:
      return "Himachali";
    case Language.Hindi:
      return "Hindi";
    case Language.Hittite:
      return "Hittite";
    case Language.Hmong:
      return "Hmong";
    case Language.HiriMotu:
      return "Hiri Motu";
    case Language.UpperSorbian:
      return "Upper Sorbian";
    case Language.Hungarian:
      return "Hungarian";
    case Language.Hupa:
      return "Hupa";
    case Language.Iban:
      return "Iban";
    case Language.Igbo:
      return "Igbo";
    case Language.Icelandic:
      return "Icelandic";
    case Language.Ido:
      return "Ido";
    case Language.SichuanYi:
      return "Sichuan Yi";
    case Language.IjoLanguages:
      return "Ijo languages";
    case Language.Inuktitut:
      return "Inuktitut";
    case Language.Interlingue:
      return "Interlingue";
    case Language.Iloko:
      return "Iloko";
    case Language.InterlinguaInternationalAuxiliaryLanguageAssociation:
      return "Interlingua (International Auxiliary Language Association)";
    case Language.IndicOther:
      return "Indic (Other)";
    case Language.Indonesian:
      return "Indonesian";
    case Language.IndoEuropeanOther:
      return "Indo-European (Other)";
    case Language.Ingush:
      return "Ingush";
    case Language.Inupiaq:
      return "Inupiaq";
    case Language.IranianOther:
      return "Iranian (Other)";
    case Language.IroquoianLanguages:
      return "Iroquoian languages";
    case Language.Italian:
      return "Italian";
    case Language.Javanese:
      return "Javanese";
    case Language.Lojban:
      return "Lojban";
    case Language.Japanese:
      return "Japanese";
    case Language.JudeoPersian:
      return "Judeo-Persian";
    case Language.JudeoArabic:
      return "Judeo-Arabic";
    case Language.KaraKalpak:
      return "Kara-Kalpak";
    case Language.Kabyle:
      return "Kabyle";
    case Language.KachinJingpho:
      return "Kachin; Jingpho";
    case Language.KalaallisutGreenlandic:
      return "Kalaallisut; Greenlandic";
    case Language.Kamba:
      return "Kamba";
    case Language.Kannada:
      return "Kannada";
    case Language.KarenLanguages:
      return "Karen languages";
    case Language.Kashmiri:
      return "Kashmiri";
    case Language.Kanuri:
      return "Kanuri";
    case Language.Kawi:
      return "Kawi";
    case Language.Kazakh:
      return "Kazakh";
    case Language.Kabardian:
      return "Kabardian";
    case Language.Khasi:
      return "Khasi";
    case Language.KhoisanOther:
      return "Khoisan (Other)";
    case Language.CentralKhmer:
      return "Central Khmer";
    case Language.Khotanese:
      return "Khotanese";
    case Language.KikuyuGikuyu:
      return "Kikuyu; Gikuyu";
    case Language.Kinyarwanda:
      return "Kinyarwanda";
    case Language.KirghizKyrgyz:
      return "Kirghiz; Kyrgyz";
    case Language.Kimbundu:
      return "Kimbundu";
    case Language.Konkani:
      return "Konkani";
    case Language.Komi:
      return "Komi";
    case Language.Kongo:
      return "Kongo";
    case Language.Korean:
      return "Korean";
    case Language.Kosraean:
      return "Kosraean";
    case Language.Kpelle:
      return "Kpelle";
    case Language.KarachayBalkar:
      return "Karachay-Balkar";
    case Language.Karelian:
      return "Karelian";
    case Language.KruLanguages:
      return "Kru languages";
    case Language.Kurukh:
      return "Kurukh";
    case Language.KuanyamaKwanyama:
      return "Kuanyama; Kwanyama";
    case Language.Kumyk:
      return "Kumyk";
    case Language.Kurdish:
      return "Kurdish";
    case Language.Kutenai:
      return "Kutenai";
    case Language.Ladino:
      return "Ladino";
    case Language.Lahnda:
      return "Lahnda";
    case Language.Lamba:
      return "Lamba";
    case Language.Lao:
      return "Lao";
    case Language.Latin:
      return "Latin";
    case Language.Latvian:
      return "Latvian";
    case Language.Lezghian:
      return "Lezghian";
    case Language.LimburganLimburgerLimburgish:
      return "Limburgan; Limburger; Limburgish";
    case Language.Lingala:
      return "Lingala";
    case Language.Lithuanian:
      return "Lithuanian";
    case Language.Mongo:
      return "Mongo";
    case Language.Lozi:
      return "Lozi";
    case Language.LuxembourgishLetzeburgesch:
      return "Luxembourgish; Letzeburgesch";
    case Language.LubaLulua:
      return "Luba-Lulua";
    case Language.LubaKatanga:
      return "Luba-Katanga";
    case Language.Ganda:
      return "Ganda";
    case Language.Luiseno:
      return "Luiseno";
    case Language.Lunda:
      return "Lunda";
    case Language.LuoKenyaAndTanzania:
      return "Luo (Kenya and Tanzania)";
    case Language.Lushai:
      return "Lushai";
    case Language.Macedonian:
      return "Macedonian";
    case Language.Madurese:
      return "Madurese";
    case Language.Magahi:
      return "Magahi";
    case Language.Marshallese:
      return "Marshallese";
    case Language.Maithili:
      return "Maithili";
    case Language.Makasar:
      return "Makasar";
    case Language.Malayalam:
      return "Malayalam";
    case Language.Mandingo:
      return "Mandingo";
    case Language.Maori:
      return "Maori";
    case Language.AustronesianOther:
      return "Austronesian (Other)";
    case Language.Marathi:
      return "Marathi";
    case Language.Masai:
      return "Masai";
    case Language.Malay:
      return "Malay";
    case Language.Moksha:
      return "Moksha";
    case Language.Mandar:
      return "Mandar";
    case Language.Mende:
      return "Mende";
    case Language.IrishMiddle9001200:
      return "Irish, Middle (900-1200)";
    case Language.MikmaqMicmac:
      return "Mi'kmaq; Micmac";
    case Language.Minangkabau:
      return "Minangkabau";
    case Language.MiscellaneousLanguages:
      return "Miscellaneous languages";
    case Language.MonKhmerOther:
      return "Mon-Khmer (Other)";
    case Language.Malagasy:
      return "Malagasy";
    case Language.Maltese:
      return "Maltese";
    case Language.Manchu:
      return "Manchu";
    case Language.Manipuri:
      return "Manipuri";
    case Language.ManoboLanguages:
      return "Manobo languages";
    case Language.Mohawk:
      return "Mohawk";
    case Language.Moldavian:
      return "Moldavian";
    case Language.Mongolian:
      return "Mongolian";
    case Language.Mossi:
      return "Mossi";
    case Language.MultipleLanguages:
      return "Multiple languages";
    case Language.MundaLanguages:
      return "Munda languages";
    case Language.Creek:
      return "Creek";
    case Language.Mirandese:
      return "Mirandese";
    case Language.Marwari:
      return "Marwari";
    case Language.MayanLanguages:
      return "Mayan languages";
    case Language.Erzya:
      return "Erzya";
    case Language.NahuatlLanguages:
      return "Nahuatl languages";
    case Language.NorthAmericanIndian:
      return "North American Indian";
    case Language.Neapolitan:
      return "Neapolitan";
    case Language.Nauru:
      return "Nauru";
    case Language.NavajoNavaho:
      return "Navajo; Navaho";
    case Language.NdebeleSouthSouthNdebele:
      return "Ndebele, South; South Ndebele";
    case Language.NdebeleNorthNorthNdebele:
      return "Ndebele, North; North Ndebele";
    case Language.Ndonga:
      return "Ndonga";
    case Language.LowGermanLowSaxonGermanLowSaxonLow:
      return "Low German; Low Saxon; German, Low; Saxon, Low";
    case Language.Nepali:
      return "Nepali";
    case Language.NepalBhasaNewari:
      return "Nepal Bhasa; Newari";
    case Language.Nias:
      return "Nias";
    case Language.NigerKordofanianOther:
      return "Niger-Kordofanian (Other)";
    case Language.Niuean:
      return "Niuean";
    case Language.NorwegianNynorskNynorskNorwegian:
      return "Norwegian Nynorsk; Nynorsk, Norwegian";
    case Language.BokmålNorwegianNorwegianBokmål:
      return "Bokmål, Norwegian; Norwegian Bokmål";
    case Language.Nogai:
      return "Nogai";
    case Language.NorseOld:
      return "Norse, Old";
    case Language.Norwegian:
      return "Norwegian";
    case Language.Nko:
      return "N'Ko";
    case Language.PediSepediNorthernSotho:
      return "Pedi; Sepedi; Northern Sotho";
    case Language.NubianLanguages:
      return "Nubian languages";
    case Language.ClassicalNewariOldNewariClassicalNepalBhasa:
      return "Classical Newari; Old Newari; Classical Nepal Bhasa";
    case Language.ChichewaChewaNyanja:
      return "Chichewa; Chewa; Nyanja";
    case Language.Nyamwezi:
      return "Nyamwezi";
    case Language.Nyankole:
      return "Nyankole";
    case Language.Nyoro:
      return "Nyoro";
    case Language.Nzima:
      return "Nzima";
    case Language.OccitanPost1500Provençal:
      return "Occitan (post 1500); Provençal";
    case Language.Ojibwa:
      return "Ojibwa";
    case Language.Oriya:
      return "Oriya";
    case Language.Oromo:
      return "Oromo";
    case Language.Osage:
      return "Osage";
    case Language.OssetianOssetic:
      return "Ossetian; Ossetic";
    case Language.TurkishOttoman15001928:
      return "Turkish, Ottoman (1500-1928)";
    case Language.OtomianLanguages:
      return "Otomian languages";
    case Language.PapuanOther:
      return "Papuan (Other)";
    case Language.Pangasinan:
      return "Pangasinan";
    case Language.Pahlavi:
      return "Pahlavi";
    case Language.Pampanga:
      return "Pampanga";
    case Language.PanjabiPunjabi:
      return "Panjabi; Punjabi";
    case Language.Papiamento:
      return "Papiamento";
    case Language.Palauan:
      return "Palauan";
    case Language.PersianOldCa600400BC:
      return "Persian, Old (ca.600-400 B.C.)";
    case Language.Persian:
      return "Persian";
    case Language.PhilippineOther:
      return "Philippine (Other)";
    case Language.Phoenician:
      return "Phoenician";
    case Language.Pali:
      return "Pali";
    case Language.Polish:
      return "Polish";
    case Language.Pohnpeian:
      return "Pohnpeian";
    case Language.Portuguese:
      return "Portuguese";
    case Language.PrakritLanguages:
      return "Prakrit languages";
    case Language.ProvençalOldTo1500:
      return "Provençal, Old (to 1500)";
    case Language.Pushto:
      return "Pushto";
    case Language.Quechua:
      return "Quechua";
    case Language.Rajasthani:
      return "Rajasthani";
    case Language.Rapanui:
      return "Rapanui";
    case Language.RarotonganCookIslandsMaori:
      return "Rarotongan; Cook Islands Maori";
    case Language.RomanceOther:
      return "Romance (Other)";
    case Language.Romansh:
      return "Romansh";
    case Language.Romany:
      return "Romany";
    case Language.Romanian:
      return "Romanian";
    case Language.Rundi:
      return "Rundi";
    case Language.AromanianArumanianMacedoRomanian:
      return "Aromanian; Arumanian; Macedo-Romanian";
    case Language.Russian:
      return "Russian";
    case Language.Sandawe:
      return "Sandawe";
    case Language.Sango:
      return "Sango";
    case Language.Yakut:
      return "Yakut";
    case Language.SouthAmericanIndianOther:
      return "South American Indian (Other)";
    case Language.SalishanLanguages:
      return "Salishan languages";
    case Language.SamaritanAramaic:
      return "Samaritan Aramaic";
    case Language.Sanskrit:
      return "Sanskrit";
    case Language.Sasak:
      return "Sasak";
    case Language.Santali:
      return "Santali";
    case Language.Serbian:
      return "Serbian";
    case Language.Sicilian:
      return "Sicilian";
    case Language.Scots:
      return "Scots";
    case Language.Croatian:
      return "Croatian";
    case Language.Selkup:
      return "Selkup";
    case Language.SemiticOther:
      return "Semitic (Other)";
    case Language.IrishOldTo900:
      return "Irish, Old (to 900)";
    case Language.SignLanguages:
      return "Sign Languages";
    case Language.Shan:
      return "Shan";
    case Language.Sidamo:
      return "Sidamo";
    case Language.SinhalaSinhalese:
      return "Sinhala; Sinhalese";
    case Language.SiouanLanguages:
      return "Siouan languages";
    case Language.SinoTibetanOther:
      return "Sino-Tibetan (Other)";
    case Language.SlavicOther:
      return "Slavic (Other)";
    case Language.Slovak:
      return "Slovak";
    case Language.Slovenian:
      return "Slovenian";
    case Language.SouthernSami:
      return "Southern Sami";
    case Language.NorthernSami:
      return "Northern Sami";
    case Language.SamiLanguagesOther:
      return "Sami languages (Other)";
    case Language.LuleSami:
      return "Lule Sami";
    case Language.InariSami:
      return "Inari Sami";
    case Language.Samoan:
      return "Samoan";
    case Language.SkoltSami:
      return "Skolt Sami";
    case Language.Shona:
      return "Shona";
    case Language.Sindhi:
      return "Sindhi";
    case Language.Soninke:
      return "Soninke";
    case Language.Sogdian:
      return "Sogdian";
    case Language.Somali:
      return "Somali";
    case Language.SonghaiLanguages:
      return "Songhai languages";
    case Language.SothoSouthern:
      return "Sotho, Southern";
    case Language.SpanishCastilian:
      return "Spanish; Castilian";
    case Language.Sardinian:
      return "Sardinian";
    case Language.SrananTongo:
      return "Sranan Tongo";
    case Language.Serer:
      return "Serer";
    case Language.NiloSaharanOther:
      return "Nilo-Saharan (Other)";
    case Language.Swati:
      return "Swati";
    case Language.Sukuma:
      return "Sukuma";
    case Language.Sundanese:
      return "Sundanese";
    case Language.Susu:
      return "Susu";
    case Language.Sumerian:
      return "Sumerian";
    case Language.Swahili:
      return "Swahili";
    case Language.Swedish:
      return "Swedish";
    case Language.Syriac:
      return "Syriac";
    case Language.Tahitian:
      return "Tahitian";
    case Language.TaiOther:
      return "Tai (Other)";
    case Language.Tamil:
      return "Tamil";
    case Language.Tatar:
      return "Tatar";
    case Language.Telugu:
      return "Telugu";
    case Language.Timne:
      return "Timne";
    case Language.Tereno:
      return "Tereno";
    case Language.Tetum:
      return "Tetum";
    case Language.Tajik:
      return "Tajik";
    case Language.Tagalog:
      return "Tagalog";
    case Language.Thai:
      return "Thai";
    case Language.Tibetan:
      return "Tibetan";
    case Language.Tigre:
      return "Tigre";
    case Language.Tigrinya:
      return "Tigrinya";
    case Language.Tiv:
      return "Tiv";
    case Language.Tokelau:
      return "Tokelau";
    case Language.KlingonTlhinganHol:
      return "Klingon; tlhIngan-Hol";
    case Language.Tlingit:
      return "Tlingit";
    case Language.Tamashek:
      return "Tamashek";
    case Language.TongaNyasa:
      return "Tonga (Nyasa)";
    case Language.TongaTongaIslands:
      return "Tonga (Tonga Islands)";
    case Language.TokPisin:
      return "Tok Pisin";
    case Language.Tsimshian:
      return "Tsimshian";
    case Language.Tswana:
      return "Tswana";
    case Language.Tsonga:
      return "Tsonga";
    case Language.Turkmen:
      return "Turkmen";
    case Language.Tumbuka:
      return "Tumbuka";
    case Language.TupiLanguages:
      return "Tupi languages";
    case Language.Turkish:
      return "Turkish";
    case Language.AltaicOther:
      return "Altaic (Other)";
    case Language.Tuvalu:
      return "Tuvalu";
    case Language.Twi:
      return "Twi";
    case Language.Tuvinian:
      return "Tuvinian";
    case Language.Udmurt:
      return "Udmurt";
    case Language.Ugaritic:
      return "Ugaritic";
    case Language.UighurUyghur:
      return "Uighur; Uyghur";
    case Language.Ukrainian:
      return "Ukrainian";
    case Language.Umbundu:
      return "Umbundu";
    case Language.Undetermined:
      return "Undetermined";
    case Language.Urdu:
      return "Urdu";
    case Language.Uzbek:
      return "Uzbek";
    case Language.Vai:
      return "Vai";
    case Language.Venda:
      return "Venda";
    case Language.Vietnamese:
      return "Vietnamese";
    case Language.Volapük:
      return "Volapük";
    case Language.Votic:
      return "Votic";
    case Language.WakashanLanguages:
      return "Wakashan languages";
    case Language.Walamo:
      return "Walamo";
    case Language.Waray:
      return "Waray";
    case Language.Washo:
      return "Washo";
    case Language.Welsh:
      return "Welsh";
    case Language.SorbianLanguages:
      return "Sorbian languages";
    case Language.Walloon:
      return "Walloon";
    case Language.Wolof:
      return "Wolof";
    case Language.KalmykOirat:
      return "Kalmyk; Oirat";
    case Language.Xhosa:
      return "Xhosa";
    case Language.Yao:
      return "Yao";
    case Language.Yapese:
      return "Yapese";
    case Language.Yiddish:
      return "Yiddish";
    case Language.Yoruba:
      return "Yoruba";
    case Language.YupikLanguages:
      return "Yupik languages";
    case Language.Zapotec:
      return "Zapotec";
    case Language.Zenaga:
      return "Zenaga";
    case Language.ZhuangChuang:
      return "Zhuang; Chuang";
    case Language.ZandeLanguages:
      return "Zande languages";
    case Language.Zulu:
      return "Zulu";
    case Language.Zuni:
      return "Zuni";
    case Language.NoLinguisticContent:
      return "No linguistic content";
    case Language.ZazaDimiliDimliKirdkiKirmanjkiZazaki:
      return "Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki.";
  }
}
